import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { verifyResponse } from "../../helpers/apiHelper";
import {
  getAllItemsFromExternalData,
  getImplementation,
} from "../API/commentAPI";

export const loadMapDataFromExternalApi = createAsyncThunk(
  "mapView/GetData",
  async (thunkAPI) => {
    const state = thunkAPI.getState();
    const implementationId = state.implementationId;
    const response = await getAllItemsFromExternalData(implementationId);
    setMapData(response);
    return verifyResponse(response, thunkAPI);
  }
);

export const loadImplementation = createAsyncThunk(
  "mapView/GetImplementation",
  async (thunkAPI) => {
    const state = thunkAPI.getState();
    const implementationId = state.implementationId;
    const response = await getImplementation(implementationId);
    setImplementation(response);
    return verifyResponse(response, thunkAPI);
  }
);

export const mapViewSlice = createSlice({
  name: "mapView",
  initialState: {
    errors: [],
    mapData: [],
    campaign: {
      id: "",
      esriFeatureLayer: "",
      name: "",
      implementationId: ""
    },
    implementation: {
      id: "",
      useMapView: true,
      active: true,
      allowMapOnModal: true,
      allowUsersToSetAlias: false, 
      moderationTimeInMinutes: 0,
      replyButtonText: "Reply",
      topLeftEastingBounds: "00000",
      topLeftNorthingBounds: "00000",
      bottomRightEastingBounds: "00000",
      bottomRightNorthingBounds: "00000",
      centrePointEasting: "00000",
      centrePointNorthing: "00000",
      useMppMapView: false
    },
  },
  reducers: {
    setMapData(state, action) {
      return {
        ...state,
        mapData: action.payload,
      };
    },
    setImplementation(state, action) {
      return {
        ...state,
        implementation: action.payload,
      };
    },
    setCampaign(state, action) {
      return {
        ...state,
        campaign: action.payload,
      };
    },
  },
});

const mapData = (state) => {
  return state.mapData;
};

const implementation = (state) => {
  return state.implementation;
};

const campaign = (state) => {
  return state.campaign; 
}

export const mapViewSelectors = {
  mapData,
  implementation,
  campaign
};

export const { setMapData, setImplementation, setCampaign } = mapViewSlice.actions;

export default mapViewSlice.reducer;
